
import React from 'react';

// A simple, reusable modal for notifications
const NotificationModal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) {
        return null;
    }

    return (
        // Overlay
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
            {/* Modal Panel */}
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md mx-4">
                <h2 className="text-xl font-bold mb-4">{title}</h2>
                <div className="mb-6">
                    {children}
                </div>
                {/* OK Button */}
                <div className="flex justify-end">
                    <button
                        onClick={onClose} // Simply closes the modal
                        className="py-2 px-4 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors"
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotificationModal;
